const config = {
    appName: 'Сытый',
    supportEmail: 'info@mvbs.ru',
    server: 'https://sitiy-api.ru',
    apiUrl: 'https://sitiy-api.ru/api/v1/admin', // 'https://bottest2.menu4me.ru/api/v1/admin', // 'https://api-test.menuforme.online/api/v1/admin',
    graphUrl: 'https://sitiy-api.ru/api/graphql/5496880-8345687-2394984-221781/admin', // 'https://api-test.menuforme.online/api/graphql/5496880-8345687-2394984-221781/admin',

    yandexMapApiKey: '32a35624-b004-474d-b343-426da5feddae', // sergey.kovalenko@sitiy.ru
    yandexMapGeocodeApiKey: '32a35624-b004-474d-b343-426da5feddae', // sergey.kovalenko@sitiy.ru
    
    socialLinks: {
        telegram: 'https://telegram.me/sitiy_support_bot',
        max: 'https://max.ru/u/f9LHodD0cOJ-AakF4JUPgCQL06ev994boUBj0eUlP3PFJvH4roUYNVKl7x4',
        whatsApp: 'https://wa.me/79914590879',
        vk: 'https://vk.me/sytofis',
        phone: '+7-800-200-69-24',
    },

    appLinks: {
        appstore: 'https://itunes.apple.com/us/app/%D1%81%D1%8B%D1%82%D1%8B%D0%B9-%D0%BE%D1%84%D0%B8%D1%81-%D0%B4%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BA%D0%B0-%D0%BE%D0%B1%D0%B5%D0%B4%D0%BE%D0%B2/id1361986950?l=ru&ls=1&mt=8',
        playmarket: 'https://play.google.com/store/apps/details?id=air.com.menu4me.dinner.sitiyoffice',
        rustore: 'https://apps.rustore.ru/app/air.com.menu4me.dinner.sitiyoffice',
    },
};

export default config;